import {
  PHOTOTHEQUE_GET_FILTERS,
  PHOTOTHEQUE_SET_CURRENT_FILTERS,
  PHOTOTHEQUE_SET_MEDIAS,
  PHOTOTHEQUE_SET_PAGINATION,
  PHOTOTHEQUE_GET_DYNAMIQUE_FILTER_VALUES,
  PHOTOTHEQUE_SET_KEY_FILTER_SELECTED
} from "./../types";

export const init = () => {
  return (dispatch, getState) => {
    const state = getState();
    dispatch(setPagination(1, state.phototheque.pages));
  };
};

function action(type, payload = {}) {
  return { type, ...payload };
}

export const getFilters = () => {
  return action(PHOTOTHEQUE_GET_FILTERS);
};

export const getMedias = data => {
  return (dispatch, getState) => {
    const state = getState();
    dispatch(setPagination(data.page, state.phototheque.pages));
  };
};

export function setFlagToMedia(media_id, flag = false) {
  return (dispatch, getState) => {
    const state = getState();
    const medias = state.phototheque.medias || [];

    for (let i = 0; i < medias.length; i++) {
      const media = medias[i];
      if (media._id === media_id) {
        media.best = flag;
      }
    }
  };
}

export const setMedias = medias => {
  return action(PHOTOTHEQUE_SET_MEDIAS, medias);
};

export const setPagination = (page, pages) => ({
  type: PHOTOTHEQUE_SET_PAGINATION,
  page,
  pages
});

const setCurrentFilters = currentFilters => ({
  type: PHOTOTHEQUE_SET_CURRENT_FILTERS,
  currentFilters
});

export function updateFilters(key, filters) {
  return (dispatch, getState) => {
    const state = getState();
    const currentFilters = state.phototheque.currentFilters || {};

    if (key === "period") {
      if (filters && filters["startDate"] && filters["endDate"]) {
        currentFilters.visit_start_date = {
          $gte: { $date: filters["startDate"] }
        };
        currentFilters.visit_end_date = { $lte: { $date: filters["endDate"] } };
      } else {
        delete currentFilters["visit_start_date"];
        delete currentFilters["visit_end_date"];
      }
    } else if (key === "best") {
      if (filters == 0) currentFilters[key] = false;
      if (filters == 1) currentFilters[key] = true;
      if (filters == 2) delete currentFilters[key];
    } else if (key === "beforeafter") {
      if (filters == 0) {
        currentFilters["before"] = true;
        currentFilters["after"] = false;
      }
      if (filters == 1) {
        currentFilters["before"] = false;
        currentFilters["after"] = true;
      }
      if (filters == 2) {
        delete currentFilters["before"];
        delete currentFilters["after"];
      }
    } else if (key === "salepoint.club_100") {
      if (filters == 0) {
        currentFilters[key] = true;
      }
      if (filters == 1) {
        currentFilters[key] = false;
      }
      if (filters == 2) {
        delete currentFilters[key];
      }
    } else {
      if (filters && filters.length && filters.length !== 0) {
        currentFilters[key] = filters;
      } else {
        delete currentFilters[key];
      }
    }
    dispatch(setCurrentFilters(currentFilters));
    dispatch(getMedias({ filters: currentFilters, page: 1 }));
  };
}

export function getDynFilterValues(key) {
  return action(PHOTOTHEQUE_GET_DYNAMIQUE_FILTER_VALUES, key);
}
export const setKeyFilterSelected = key => ({
  type: PHOTOTHEQUE_SET_KEY_FILTER_SELECTED,
  key
});



// WEBPACK FOOTER //
// src/redux/actions/photothequeActions.js